import { useContext } from "react";
import { BreakGlassContext, type BreakGlassContextValue } from "@/providers/break-glass-provider";

export function useBreakGlass(): BreakGlassContextValue {
  const ctx = useContext(BreakGlassContext);
  if (!ctx) {
    throw new Error("useBreakGlass must be used within BreakGlassProvider");
  }
  return ctx;
}
